import React, { useState } from 'react';
import { Typography } from 'fronton-react';
import { ChevronRightIcon } from '@fronton/icons-react';
import { BaseModal } from './modals';
import {
	CurtainsKindContainer,
	CurtainsKindModal,
	CurtainsKindText,
	CurtainsKindTextChevron,
	imgStyles,
	pictureStyles,
} from './styles';

type ImgUrls = {
	lDesk: string;
	desk: string;
	tab: string;
};

type BaseCurtainsKindProps = {
	dataQa: string;
	text: string;
	imgUrls: ImgUrls;
	modalImgUrl: string;
	modalTitle: string;
	modalContentItems: string[];
	modalButtonText: string;
	modalImgAlt: string;
	onModalButtonClick: VoidFunction;
};

export const CurtainsKind = ({
	text,
	imgUrls,
	dataQa,
	modalButtonText,
	modalContentItems,
	modalTitle,
	modalImgUrl,
	modalImgAlt,
	onModalButtonClick,
}: BaseCurtainsKindProps) => {
	const [isOpen, setIsOpen] = useState(false);
	const toggleOpen = () => setIsOpen(prev => !prev);
	return (
		<>
			<CurtainsKindContainer data-qa={dataQa} role="button" onClick={toggleOpen}>
				<picture className={pictureStyles}>
					<source srcSet={imgUrls.tab} media="(max-width: 1023px)" />
					<source srcSet={imgUrls.desk} media="(max-width: 1199px)" />
					<source srcSet={imgUrls.lDesk} media="(max-width: 1365px)" />
					<img className={imgStyles} src={imgUrls.lDesk} alt={modalImgAlt} />
				</picture>
				<CurtainsKindText>
					<Typography size="subtitle" variant="m">
						{text}
					</Typography>
					<CurtainsKindTextChevron>
						<ChevronRightIcon
							strokeWidth={1.25}
							type="outline"
							size="m"
							color="text-primary"
						/>
					</CurtainsKindTextChevron>
				</CurtainsKindText>
			</CurtainsKindContainer>
			<CurtainsKindModal>
				<BaseModal
					isOpen={isOpen}
					title={modalTitle}
					contentItems={modalContentItems}
					buttonText={modalButtonText}
					imgUrl={modalImgUrl}
					onClose={toggleOpen}
					onClick={onModalButtonClick}
				/>
			</CurtainsKindModal>
		</>
	);
};
